import React from 'react';
import BuildOutlined from '@mui/icons-material/BuildOutlined';
import EventRepeatOutlined from '@mui/icons-material/EventRepeatOutlined';

const OPTIONS = [
  {
    value: 'corrective',
    label: 'Service request',
    description: 'Reactive, corrective work',
    icon: BuildOutlined,
  },
  {
    value: 'preventive',
    label: 'Preventive maintenance',
    description: 'Scheduled PPM work',
    icon: EventRepeatOutlined,
  },
];

/**
 * Two 16px radio dots were the entire control for the single most consequential
 * choice on this form — it changes which fields exist. Selectable cards make the
 * choice legible and give it a real touch target.
 */
const MaintenanceTypeSelector = ({ maintenanceType, setMaintenanceType }) => (
  <fieldset className="mb-8">
    <legend className="mb-3 text-sm font-semibold uppercase tracking-wide text-muted-fg">
      Maintenance type
    </legend>

    <div className="grid gap-3 sm:grid-cols-2">
      {OPTIONS.map(({ value, label, description, icon: Icon }) => {
        const selected = maintenanceType === value;
        return (
          <label
            key={value}
            className={[
              'flex cursor-pointer items-start gap-3 rounded-lg border p-4',
              'transition-all duration-base ease-out',
              selected
                ? 'border-accent bg-accent-soft ring-2 ring-accent/30'
                : 'border-border bg-surface hover:border-border-strong hover:bg-muted',
            ].join(' ')}
          >
            <input
              type="radio"
              name="maintenanceType"
              value={value}
              checked={selected}
              onChange={(e) => setMaintenanceType(e.target.value)}
              className="sr-only"
            />
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${
                selected ? 'bg-accent text-accent-fg' : 'bg-muted text-muted-fg'
              }`}
            >
              <Icon style={{ fontSize: 20 }} aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-foreground">{label}</span>
              <span className="block text-sm text-muted-fg">{description}</span>
            </span>
          </label>
        );
      })}
    </div>
  </fieldset>
);

export default MaintenanceTypeSelector;
